import { useEffect, useState } from "react";
import { Link } from "react-router";
import { Button, Rating } from "@shop/ui";
import { formatPrice } from "@shop/utils";
import { fetchProducts } from "../api.ts";
import type { Product } from "../data/products.ts";
import { Pic } from "../components/Pic.tsx";
import "./home.css";

export default function Home() {
  const [products, setProducts] = useState<Product[] | null>(null);
  useEffect(() => { fetchProducts().then(setProducts); }, []);

  return (
    <>
      <section className="hero">
        <div className="text">
          <h1>秋季新品</h1>
          <p>实木、亚麻、藤编。放得住的东西。</p>
          <Link to="/p/linen-sofa"><Button size="lg">看看沙发</Button></Link>
        </div>
      </section>
      <h2>全部商品</h2>
      {!products ? <p className="empty">加载中…</p> : (
        <div className="grid">
          {products.map((p) => (
            <Link key={p.id} to={`/p/${p.slug}`} className="card">
              <Pic name={p.slug} alt={p.name} sizes="(max-width: 720px) 50vw, 240px" loading="lazy" />
              <h3>{p.name}</h3>
              <div className="p">{formatPrice(p.price)}</div>
              <Rating value={p.rating} count={p.reviews} />
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
